export default __webpack_public_path__ + "static/media/home-decor-2.6811a417.jpg";